import { render, staticRenderFns } from "./BackspacePressTags.vue?vue&type=template&id=6c2c354e"
import script from "./BackspacePressTags.vue?vue&type=script&lang=js"
export * from "./BackspacePressTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports